import { CircularProgress } from "@mui/material";
import React, { createContext, useContext, useState } from "react";
import PropTypes from "prop-types";

// Create context
const LoadingContext = createContext();

// Provider
export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);

  return (
    <LoadingContext.Provider value={{ setLoading }}>
      {children}
      {loading && <FullPageLoader />}
    </LoadingContext.Provider>
  );
};

LoadingProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

// Hook
export const useLoading = () => useContext(LoadingContext);

// Loader component
const FullPageLoader = () => (
  <div style={overlayStyle}>
    <CircularProgress color="error" />
  </div>
);

// CSS styles
const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 9999,
};
